<script setup lang="ts"></script>

<template>
    <div>
        <embed src="/pdf/politika-privatnosti.pdf" width="1440px" height="900px" />
    </div>
</template>

<style lang="scss" scoped></style>